/**
 * UserApp ist der Einstiegspunkt für den Editor. Die Module werden unterschieden und die Navigation wird bereit gestellt.
 */

import React from 'react'

import EditorDashboard from './EditorDashboard/EditorDashboard'
import EditorAccounts from './EditorAccounts/EditorAccounts'

import { EditorScreen, Navigation } from '@professocial/professocialTypes/types/commonTypes'

import { Container } from '@mui/material'

import { useRouteMatch } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import EditorTopics from './EditorTopics/EditorTopics'
import EditorImprint from './EditorImprint/EditorImprint'
import EditorImages from './EditorImages/EditorImages'
import EditorHelp from './EditorHelp/EditorHelp'
import EditorStatistics from './EditorStatistics/EditorStatistics'
import EditorAnnouncement from './EditorAnnouncement/EditorAnnouncement'

export enum EditorDashboardSubScreen {
  networkContent = 'networkContent',
  posting = 'posting',
  calendar = 'calendar',
}

export enum EditorAccountsSubScreen {
  user = 'user',
  deactivated = 'deactivated',
}

export enum EditorImagesSubScreen {
  titleImages = 'titleImages',
  profileImages = 'profileImages',
  mediaGallery = 'mediaGallery',
}

export const navigationEditorListData: Navigation[] = [
  {
    value: 'dashboard',
    label: 'dashboard',
    key: 'dashboard',
    changeTo: EditorScreen.dashboard,
  },
  {
    value: 'statistics',
    label: 'statistics',
    key: 'statistics',
    changeTo: EditorScreen.statistics,
  },
  {
    value: 'accounts',
    label: 'accounts',
    key: 'accounts',
    changeTo: EditorScreen.accounts,
  },
  {
    value: 'topics',
    label: 'topics',
    key: 'topics',
    changeTo: EditorScreen.topics,
  },
  {
    value: 'imprint',
    label: 'imprint',
    key: 'imprint',
    changeTo: EditorScreen.imprint,
  },
  {
    value: 'announcement',
    label: 'announcement',
    key: 'announcement',
    changeTo: EditorScreen.announcement,
  },
  {
    value: 'images',
    label: 'images',
    key: 'images',
    changeTo: EditorScreen.images,
  },
  {
    value: 'help',
    label: 'help',
    key: 'help',
    changeTo: EditorScreen.help,
  },
]

const EditorApp: React.FC = () => {
  const { path } = useRouteMatch()

  return (
    <>
      <Switch>
        <Route path={`${path}/dashboard`}>
          <Container maxWidth='lg'>
            <EditorDashboard />
          </Container>
        </Route>
        <Route path={`${path}/statistics`}>
          <Container maxWidth='xl'>
            <EditorStatistics />
          </Container>
        </Route>
        <Route path={`${path}/accounts`}>
          <Container maxWidth='xl'>
            <EditorAccounts />
          </Container>
        </Route>
        <Route path={`${path}/topics`}>
          <Container maxWidth='lg'>
            <EditorTopics />
          </Container>
        </Route>
        <Route path={`${path}/images`}>
          <Container maxWidth='lg'>
            <EditorImages />
          </Container>
        </Route>
        <Route path={`${path}/imprint`}>
          <Container maxWidth='lg'>
            <EditorImprint />
          </Container>
        </Route>
        <Route path={`${path}/announcement`}>
          <Container maxWidth='lg'>
            <EditorAnnouncement />
          </Container>
        </Route>
        <Route path={`${path}/help`}>
          <Container maxWidth='lg'>
            <EditorHelp />
          </Container>
        </Route>
      </Switch>
    </>
  )
}
export default EditorApp
